import React, { useContext } from "react";
import ModalCourseDetails from "lib/components/MyLearning/components/CourseDetails";
import ProgramContext from "../ProgramContext";

const ProgramCourseDetails = (props) => {
  const ProgramSettings = useContext(ProgramContext);
  const { course, activityId } = props;
  const classroomCourse = {
    ...course,
    courseId: course.courseObjectId,
  };

  return (
    <ModalCourseDetails
      initiallyOpen
      title={course.title}
      dialogStyles={{ minWidth: "450px" }}
      course={classroomCourse}
      closeDetails={() => props.onClose(false)}
      personalId={ProgramSettings.userId}
      activityId={activityId}
      isManagerOrAdmin={ProgramSettings.managerView}
    />
  );
};

export default ProgramCourseDetails;
